import { getDetailedTime } from './getDetailedTime'

export function formatElapsedTime(milliseconds: number): string {
  const { hours, minutes, seconds } = getDetailedTime(milliseconds)

  return `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`
}

export function getElapsedTime(start: Date | null, end: Date | null): string {
  if (!start || !end) {
    return '--h --m --s'
  }

  const elapsedTime = Math.max(0, end.getTime() - start.getTime())
  return formatElapsedTime(elapsedTime)
}
